import { SxProps } from '@mui/material';

export const DpOutlinedSelectSX: SxProps = {
	fontSize: '15px',
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#C9C9C9',
	},
	height: '48px',
	'.MuiOutlinedInput-root': {
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	'.MuiOutlinedInput-notchedOutline': {
		borderColor: '#C9C9C9',
	},
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#0467D2',
	},
	'& .MuiSelect-iconOpen': {
		transform: 'none',
	},
};
